import { mapGetters } from "vuex";
import { getAge } from "../utils";
import types from "../store/types";
import store from "../store";
import {
  DESTINATIONS,
  FACILITY_CODES,
  PORTS,
  VISA_TYPE_REQUIRING_ATTACHMENTS,
} from "../constants";

export default {
  computed: {
    ...mapGetters([
      types.getters.contacts,
      types.getters.booking,
      types.getters.cabinConfigurations,
      types.getters.visaRequirementByContactID,
      types.getters.passportByContactID,
      types.getters.preArrangementByContactIDAndCategory,
      types.getters.postArrangementByContactIDAndCategory,
    ]),
  },
  methods: {
    getFullName: (contact) => {
      return `${contact.firstName}${contact.middleName ? " " + contact.middleName : ""}${contact.lastName ? " " + contact.lastName : ""}`;
    },
    getFullNameByContactId: function (contactId) {
      const contact = store.getters[types.getters.contact](contactId);
      return this.getFullName(contact);
    },
    getEmergencyFullName: (contact) => {
      return `${contact.emergencyContactFirstName ? contact.emergencyContactFirstName : ""}${contact.emergencyContactMiddleName ? " " + contact.emergencyContactMiddleName : ""}${contact.emergencyContactLastName ? " " + contact.emergencyContactLastName : ""}`;
    },
    getPastTravelPeriodField: (pastGuestLocation) => {
      switch (pastGuestLocation) {
        case DESTINATIONS.Amazon:
          return types.fields.pastTravelPeriod.Amazon;
        case DESTINATIONS.Mekong:
          return types.fields.pastTravelPeriod.Mekong;
        case DESTINATIONS.Indonesia:
          return types.fields.pastTravelPeriod.Indonesia;
        case DESTINATIONS.Ecuador:
          return types.fields.pastTravelPeriod.Ecuador;
      }
      return "";
    },
    getContactMandatoryFields: () => {
      const booking = store.getters["booking"];
      const mandatoryFields = [
        "title",
        "firstName",
        "lastName",
        "dateOfBirth",
        // 'email', // Email is meant to be optional now
        "mainMailingCountry",
        "nationality",
        "gender",
        "emergencyContactFirstName",
        "emergencyContactLastName",
        "emergencyContactPhone",
        "emergencyContactRelation",
        "dietaryAllergies",
        "medicalNotes",
      ];

      if (booking && !booking.isAmazonCruise) {
        mandatoryFields.push("passportIssueDate");
      }

      // if (
      //   booking &&
      //   (!booking.isAmazonCruise ||
      //     !booking.facilityCode == FACILITY_CODES.AquaBlu)
      // ) {
      //   mandatoryFields.push("dietaryPreferences");
      // }
      return mandatoryFields;
    },
    getContactBookingMandatoryFields: () => {
      const mandatoryFields = [];
      return mandatoryFields;
    },
    isBedConfigurable: function (cabinConfiguration) {
      if (
        this.booking.facilityCode !== FACILITY_CODES.AquaBlu &&
        this.booking.facilityCode !== FACILITY_CODES.AquaMare &&
        this.booking.facilityCode !== FACILITY_CODES.AquaLares
      ) {
        return true;
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
        if (["202", "204"].indexOf(cabinConfiguration.cabin) >= 0) {
          return false;
        }
        const aquaBluConfigurableCabins = ["202", "204"];
        return aquaBluConfigurableCabins.indexOf(cabinConfiguration.cabin) >= 0;
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaLares) {
        const aquaLaresConfigurableCabins = ["104", "105", "301", "302"];
        return (
          aquaLaresConfigurableCabins.indexOf(cabinConfiguration.cabin) >= 0
        );
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
        return false;
      }
    },
    isAquaLares: function () {
      return this.booking.facilityCode === FACILITY_CODES.AquaLares;
    },
    hasDiving: function () {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return (
        this.booking.facilityCode === FACILITY_CODES.AquaBlu ||
        (this.booking.facilityCode === FACILITY_CODES.AquaLares &&
          !this.booking.isArcticCruise)
      );
    },
    canDive: function (contact) {
      const age = getAge(new Date(contact.dateOfBirth));
      return age >= 8;
    },
    hasWetsuit: function () {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === FACILITY_CODES.AquaMare;
    },
    isPostArrangementDriverFieldMandatory: function (contact) {
      const portToLocationArrangement =
        this.postArrangementByContactIDAndCategory(
          contact.contactID,
          "Port to location",
        );
      if (!portToLocationArrangement) {
        return false;
      }
      if (
        this.booking.arrivalPort === PORTS.SiemReap ||
        this.booking.arrivalPort === PORTS.HoChiMinh
      ) {
        if (
          portToLocationArrangement.postArrangementAction ===
            "sharedTransfer" &&
          portToLocationArrangement.typeOfArrangement === "AE Shared transfer"
        ) {
          return true;
        }
      }
      return false;
    },
    isPostArrangementFlightFieldMandatory: function (contact) {
      const portToLocationArrangement =
        this.postArrangementByContactIDAndCategory(
          contact.contactID,
          "Port to location",
        );
      if (!portToLocationArrangement) {
        return false;
      }
      if (
        this.booking.arrivalPort === PORTS.SiemReap ||
        this.booking.arrivalPort === PORTS.HoChiMinh
      ) {
        if (
          portToLocationArrangement.postArrangementAction ===
            "sharedTransfer" &&
          portToLocationArrangement.typeOfArrangement === "AE Shared transfer"
        ) {
          return true;
        }
      }
      return false;
    },
    isPostArrangementAccommodationFieldMandatory: function (contact) {
      const portToLocationArrangement =
        this.postArrangementByContactIDAndCategory(
          contact.contactID,
          "Port to location",
        );
      if (!portToLocationArrangement) {
        return false;
      }
      if (portToLocationArrangement.postArrangementAction === "hotel") {
        return true;
      }
      if (
        this.booking.arrivalPort === PORTS.SiemReap ||
        this.booking.arrivalPort === PORTS.HoChiMinh
      ) {
        if (
          portToLocationArrangement.postArrangementAction ===
            "sharedTransfer" &&
          portToLocationArrangement.typeOfArrangement === "AE Shared transfer"
        ) {
          return true;
        }
      }
      return false;
    },
    isPreArrangementAccommodationFieldMandatory: function (contact) {
      const accommodationArrangement =
        this.preArrangementByContactIDAndCategory(
          contact.contactID,
          "Accommodation",
        );
      if (!accommodationArrangement) {
        return false;
      }
      // 20250408: Request by client to include accommodation for AQM and AQB
      // if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
      //   return false;
      // }
      // if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
      //   return false;
      // }
      if (!accommodationArrangement.arrivePriorToCruise) {
        return false;
      }
      return true;
      // return this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
      //   && !this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight').takingRecommendedFlight
    },
    getTotalProgressData: function () {
      const basicMandatoryFields = this.getContactMandatoryFields();
      const basicContactBookingMandatoryFields =
        this.getContactBookingMandatoryFields();
      let totalMandatoryFields = 0;
      let totalCompletedFields = 0;
      let emptyFields = [];
      const fieldDisplayName = {
        nameOfPerson: "driverName",
        from: "pickUpLocation",
        contactNo: "contactNumber",
        pastGuest: "previousAquaCruisePeriod",
      };

      this.contacts.forEach((contact) => {
        const { contactID } = contact;
        const mandatoryFields = basicMandatoryFields.slice();

        // for amazon cruise, if guest in Peruvian - we only collect the national ID
        if (this.booking.isAmazonCruise) {
          if (
            contact.nationality === "PE - Peru" &&
            contact.mainMailingCountry === "PE - Peru"
          ) {
            mandatoryFields.push("nationalIdNumber");
          }
        } else {
          //'passportNumber', 'passportIssuingCountry', 'passportExpiryDate',
          mandatoryFields.push("passportNumber");
          mandatoryFields.push("passportIssuingCountry");
          mandatoryFields.push("passportExpiryDate");
        }

        // Diving checks
        const contactBookingMandatoryFields =
          basicContactBookingMandatoryFields.slice();
        const contactBooking =
          store.getters[types.getters.contactBooking](contactID);

        if (
          this.hasWetsuit() &&
          (contactBooking.needWetsuit === true ||
            contactBooking.needWetsuit === "true")
        ) {
          contactBookingMandatoryFields.push("wetsuit");
          if (contactBooking.wetsuit === "Other") {
            contactBookingMandatoryFields.push("wetsuitOther");
          }
        }

        if (
          this.hasDiving() &&
          this.canDive(contact) &&
          (contactBooking.planningToDive === true ||
            contactBooking.planningToDive === "true")
        ) {
          contactBookingMandatoryFields.push(
            "dateOfLastDive",
            "divingExperienceLevel",
            "divingFins",
            "divingAssociation",
            "divingCertificationNumber",
            "divingWetsuit",
          );
          if (contactBooking.divingAssociation === "Other") {
            contactBookingMandatoryFields.push("divingAssociationOther");
          }
          if (contactBooking.divingWetsuit === "Other") {
            contactBookingMandatoryFields.push("divingWetsuitOther");
          }
          if (contactBooking.divingFins === "Other") {
            contactBookingMandatoryFields.push("divingFinsOther");
          }
        }

        const completedFields = mandatoryFields.filter((field) => {
          if (
            !contact[field] ||
            (Array.isArray(contact[field]) && contact[field].length <= 0)
          ) {
            emptyFields.push({ field, contactID });
          }

          return contact[field];
        });
        completedFields.push(
          ...contactBookingMandatoryFields.filter((field) => {
            if (
              !contactBooking[field] ||
              (Array.isArray(contactBooking[field]) &&
                contactBooking[field].length <= 0)
            ) {
              emptyFields.push({ field, contactID });
            }

            return contactBooking[field];
          }),
        );

        let numMandatoryFields =
          mandatoryFields.length + contactBookingMandatoryFields.length;
        let numCompletedFields = completedFields.length;

        if (contact.hasPastGuest) {
          numMandatoryFields++;
          numCompletedFields += contact.pastGuest[0] ? 1 : 0;

          if (contact.pastGuest.length === 0 || contact.pastGuest[0] === "") {
            emptyFields.push({ field: "pastGuest", contactID });
          }
        }

        const visaRequirement = this.visaRequirementByContactID(contactID);
        if (
          visaRequirement &&
          VISA_TYPE_REQUIRING_ATTACHMENTS.indexOf(visaRequirement.visaType) >= 0
        ) {
          numMandatoryFields++;

          if (
            visaRequirement._relativePath ||
            (visaRequirement.attachmentID &&
              !visaRequirement._removeUploadedVisa)
          ) {
            numCompletedFields++;
          } else {
            emptyFields.push({ field: "visaImage", contactID });
          }
        }

        // Passport image is mandatory
        const passport = this.passportByContactID(contactID);
        numMandatoryFields++;
        if (
          passport._relativePath ||
          (passport.attachmentID && !passport._removeUploadedPassport)
        ) {
          numCompletedFields++;
        } else {
          emptyFields.push({ field: "passportImage", contactID });
        }

        const preArrangementFlight = this.preArrangementByContactIDAndCategory(
          contactID,
          "Flight",
        );
        const preArrangementAccommodation =
          this.preArrangementByContactIDAndCategory(contactID, "Accommodation");
        const preArrangementLocationToPort =
          this.preArrangementByContactIDAndCategory(
            contactID,
            "Location to port",
          );

        if (
          preArrangementFlight &&
          !preArrangementFlight.notTakingAFlight &&
          !preArrangementFlight.flightBookedByAqua
        ) {
          // Taking a flight
          const flightFields = ["flightNumber", "arrivalDate", "arrivalTime"];
          // const accommodationFields = ['accommodationName']
          const locationToPortFields = []; // ['typeOfArrangement'] handled in the next section
          numMandatoryFields += flightFields.length;
          numCompletedFields += flightFields.reduce((accumulate, current) => {
            if (!preArrangementFlight[current]) {
              emptyFields.push({
                field: current,
                contactID,
                preArrangementID: preArrangementFlight.preArrangementID,
              });
              return accumulate;
            }
            accumulate++;
            return accumulate;
          }, 0);
          // if (preArrangementAccommodation && this.booking.isAmazonCruise) {
          //   // Accommodation is mandatory for Amazon cruise only
          //   numMandatoryFields += accommodationFields.length
          //   numCompletedFields += accommodationFields.reduce((accumulate, current) => {
          //     if (!preArrangementAccommodation[current]) {
          //       emptyFields.push({ field: current, contactID, preArrangementID: preArrangementAccommodation.preArrangementID })
          //       return accumulate
          //     }
          //     accumulate++
          //     return accumulate
          //   }, 0)
          // }
          if (this.booking.isGalapagosCruise) {
            numMandatoryFields++;
            if (!preArrangementFlight["galapagosRouteInfo"]) {
              emptyFields.push({
                field: "EmbarkingFrom",
                contactID,
                preArrangementID: preArrangementAccommodation.preArrangementID,
              });
            } else {
              numCompletedFields++;
            }
          }
          if (preArrangementLocationToPort) {
            numMandatoryFields += locationToPortFields.length;
            numCompletedFields += locationToPortFields.reduce(
              (accumulate, current) => {
                if (!preArrangementLocationToPort[current]) {
                  emptyFields.push({
                    field: current,
                    contactID,
                    preArrangementID:
                      preArrangementLocationToPort.preArrangementID,
                  });
                  return accumulate;
                }
                accumulate++;
                return accumulate;
              },
              0,
            );
          }
        }
        // else if (preArrangementFlight && preArrangementFlight.notTakingAFlight && this.booking.isAmazonCruise) {
        if (this.isPreArrangementAccommodationFieldMandatory(contact)) {
          const accommodationFields = ["accommodationName"];
          numMandatoryFields += accommodationFields.length;
          numCompletedFields += accommodationFields.reduce(
            (accumulate, current) => {
              if (!preArrangementAccommodation[current]) {
                emptyFields.push({
                  field: current,
                  contactID,
                  preArrangementID:
                    preArrangementAccommodation.preArrangementID,
                });
                return accumulate;
              }
              accumulate++;
              return accumulate;
            },
            0,
          );
        }

        // preArrangementLocationToPort
        if (
          preArrangementLocationToPort &&
          !preArrangementLocationToPort.typeOfArrangement &&
          !this.booking.isGalapagosCruise
        ) {
          numMandatoryFields++;
          emptyFields.push({
            field: "typeOfPreCruiseArrangement",
            contactID,
            preArrangementID: preArrangementLocationToPort.preArrangementID,
          });
        }

        if (
          preArrangementLocationToPort &&
          (!preArrangementLocationToPort.dateOfEntryToPeru ||
            !preArrangementLocationToPort.entryToPeruFrom) &&
          this.booking.isAmazonCruise &&
          contact.mainMailingCountry !== "PE - Peru"
        ) {
          if (!preArrangementLocationToPort.dateOfEntryToPeru) {
            numMandatoryFields++;
            emptyFields.push({
              field: "dateOfEntryToPeru",
              contactID,
              preArrangementID: preArrangementLocationToPort.preArrangementID,
            });
          }

          if (!preArrangementLocationToPort.entryToPeruFrom) {
            numMandatoryFields++;
            emptyFields.push({
              field: "entryToPeruFrom",
              contactID,
              preArrangementID: preArrangementLocationToPort.preArrangementID,
            });
          }
        }

        if (
          preArrangementLocationToPort &&
          preArrangementLocationToPort.typeOfArrangement === "By 3rd party"
        ) {
          const fields = ["localHandler", "nameOfPerson", "contactNo", "from"];
          numMandatoryFields += fields.length;
          numCompletedFields += fields.reduce((accumulate, current) => {
            if (!preArrangementLocationToPort[current]) {
              emptyFields.push({
                field: current,
                contactID,
                preArrangementID: preArrangementLocationToPort.preArrangementID,
              });
              return accumulate;
            }

            accumulate++;
            return accumulate;
          }, 0);
        }

        // postArrangementPortToLocation
        const postArrangementPortToLocation =
          this.postArrangementByContactIDAndCategory(
            contactID,
            "Port to location",
          );
        if (
          postArrangementPortToLocation &&
          !postArrangementPortToLocation.typeOfArrangement &&
          !this.booking.isGalapagosCruise
        ) {
          numMandatoryFields++;
          emptyFields.push({
            field: "typeOfPostCruiseArrangement",
            contactID,
            postArrangementID: postArrangementPortToLocation.postArrangementID,
          });
        }

        if (
          postArrangementPortToLocation &&
          postArrangementPortToLocation.typeOfArrangement === "By 3rd party"
        ) {
          const fields = ["localHandler", "nameOfPerson", "contactNo"];
          numMandatoryFields += fields.length;
          numCompletedFields += fields.reduce((accumulate, current) => {
            if (!postArrangementPortToLocation[current]) {
              emptyFields.push({
                field: current,
                contactID,
                postArrangementID:
                  postArrangementPortToLocation.postArrangementID,
              });
              return accumulate;
            }

            accumulate++;
            return accumulate;
          }, 0);
        }

        if (
          postArrangementPortToLocation &&
          (postArrangementPortToLocation.postArrangementAction === "airport" ||
            this.booking.isGalapagosCruise)
        ) {
          const postArrangementFlight =
            this.postArrangementByContactIDAndCategory(contactID, "Flight");
          if (
            postArrangementFlight &&
            !postArrangementFlight.notTakingAFlight &&
            !postArrangementFlight.flightBookedByAqua
          ) {
            const fields = ["flightNumber", "departureDate", "departureTime"];
            numMandatoryFields += fields.length;
            numCompletedFields += fields.reduce((accumulate, current) => {
              if (!postArrangementFlight[current]) {
                emptyFields.push({
                  field: current,
                  contactID,
                  postArrangementID: postArrangementFlight.postArrangementID,
                });
                return accumulate;
              }

              accumulate++;
              return accumulate;
            }, 0);

            if (this.booking.isGalapagosCruise) {
              if (!postArrangementFlight["galapagosRouteInfo"]) {
                emptyFields.push({
                  field: "DisembarkingFrom",
                  contactID,
                  preArrangementID: postArrangementFlight.preArrangementID,
                });
              }
            }
          }

          if (
            postArrangementFlight &&
            postArrangementFlight.takingRecommendedFlight &&
            !postArrangementFlight.flightBookedByAqua
          ) {
            const fields = ["referenceNumber"];
            numMandatoryFields += fields.length;
            numCompletedFields += fields.reduce((accumulate, current) => {
              if (!postArrangementFlight[current]) {
                emptyFields.push({
                  field: current,
                  contactID,
                  postArrangementID: postArrangementFlight.postArrangementID,
                });
                return accumulate;
              }

              accumulate++;
              return accumulate;
            }, 0);
          }
        }
        if (this.isPostArrangementAccommodationFieldMandatory(contact)) {
          const accommodationFields = ["accommodationName"];
          const postArrangementAccommodation =
            this.postArrangementByContactIDAndCategory(
              contactID,
              "Accommodation",
            );
          if (postArrangementAccommodation) {
            numMandatoryFields += accommodationFields.length;
            numCompletedFields += accommodationFields.reduce(
              (accumulate, current) => {
                if (!postArrangementAccommodation[current]) {
                  emptyFields.push({
                    field: current,
                    contactID,
                    postArrangementID:
                      postArrangementAccommodation.postArrangementID,
                  });
                  return accumulate;
                }
                accumulate++;
                return accumulate;
              },
              0,
            );
          }
        }

        totalMandatoryFields += numMandatoryFields;
        totalCompletedFields += numCompletedFields;
      });

      this.cabinConfigurations.forEach((cabinConfiguration) => {
        const { cabinBedding, cabinConfigurationID } = cabinConfiguration;
        // Only add cabin configuration as mandatory if it is configurable
        if (!this.isBedConfigurable(cabinConfiguration)) {
          return;
        }
        totalMandatoryFields++;
        totalCompletedFields += cabinBedding ? 1 : 0;

        if (!cabinBedding) {
          emptyFields.push({ field: "cabinBedding", cabinConfigurationID });
        }
      });

      // Replace fields with easier to understand display names if available
      emptyFields = emptyFields.map((emptyField) => {
        emptyField.field = fieldDisplayName[emptyField.field]
          ? fieldDisplayName[emptyField.field]
          : emptyField.field;
        return emptyField;
      });

      console.log("emptyFields:", emptyFields);
      const percentage = Math.round(
        (totalCompletedFields / totalMandatoryFields) * 100,
      );

      return {
        percentage,
        emptyFields,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/contact.js